module.exports = __webpack_public_path__ + "static/media/christmas.866c94ee.jpg";